import React from "react";
import "./SubjectCard.css";

const PerformanceCard = ({
  subject,
  score,
  totalMarks,
  percentile,
  strengthLabel,
  correct,
  wrong,
  skipped,
  totalQuestions,
}) => {
  const safeTotalQuestions = totalQuestions > 0 ? totalQuestions : 1;
  const correctPercentage = (correct / safeTotalQuestions) * 100;
  const wrongPercentage = (wrong / safeTotalQuestions) * 100;
  const skippedPercentage = (skipped / safeTotalQuestions) * 100;

  return (
    <div className="performance-card">
      <div className="performance-header">
        <h3>{subject}</h3>
        {strengthLabel ? <span className="strength-badge">{strengthLabel}</span> : null}
      </div>

      <p className="score-text">
        Your Score is {score} out of {totalMarks} marks
      </p>

      <div className="percentile-row">
        <span>Accuracy</span>

        <div className="percentile-bar">
          <span className="correct-bar" style={{ width: `${correctPercentage}%` }} />
          <span className="wrong-bar" style={{ width: `${wrongPercentage}%` }} />
          <span className="skipped-bar" style={{ width: `${skippedPercentage}%` }} />
        </div>

        <strong>{percentile}%</strong>
      </div>

      <div className="divider" />

      <div className="result-row">
        <div className="result correct-result">
          <span className="result-icon"><i className="bi bi-check"></i></span>
          <span>{correct} Correct</span>
        </div>

        <div className="vertical-line" />

        <div className="result wrong-result">
          <span className="result-icon"><i className="bi bi-x"></i></span>
          <span>{wrong} Wrong</span>
        </div>

        <div className="vertical-line" />

        <div className="result skipped-result">
          <span className="result-icon"><i className="bi bi-dash"></i></span>
          <span>{skipped} Skipped</span>
        </div>
      </div>

      <div className="bottom-row">
        <span>Attempted: {Math.min(correct + wrong, totalQuestions)}/{totalQuestions}</span>
        <span>Total Questions: {totalQuestions}</span>
      </div>
    </div>
  );
};

const SubjectPerformance = ({ subjects = [] }) => {
  return (
    <section className="subject-performance mt-20">
      <h2>YOUR SUBJECT WISE PERFORMANCE IN THIS TEST</h2>

      <div className="instructionContent">
        <div className="quiz-inst-text">
          {subjects.length ? (
            <div className="performance-grid">
              {subjects.map((subject, index) => (
                <PerformanceCard key={subject.subjectId || index} {...subject} />
              ))}
            </div>
          ) : (
            <div className="quiz-empty mt-3">
              <i className="bi bi-bar-chart" />
              <h3>No subject performance available</h3>
              <p>This attempt does not have subject-wise analytics yet.</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default SubjectPerformance;
